module.exports = __webpack_public_path__ + "media/images/steps/step_11-dfb962aebf8d42665540e07779ec3cdb.svg";